import React from 'react';
import { components } from 'common'
const { PreImg } = components;

export interface IGridItem {
    id: string;
    icon: string;
    title: string;
}

interface IProps {
    data: IGridItem[];
    column?: number;
    textRow?: number;
    onItemClick(item: IGridItem): void;
}

import './transformersGrid.scss';

/**
 * @desc 金刚区
 * @author Kody
 */
export const TransformersGrid = (props: IProps) => {
    const { data, onItemClick, column = 4, textRow = 2 } = props;
    const renderList = () => {
        const style = {
            flex: `0 0 ${(1 / column) * 100}%`,
        };
        return data.map((item) => {
            return (
                <li
                    key={item.id}
                    style={style}
                    onClick={() => onItemClick(item)}
                    className="grid-nav-item"
                >
                    <PreImg><img src={`${item.icon}?v=1`}/></PreImg>
                    <div className={`title umu-text-clamp clamp-${textRow}`}>
                        {item.title}
                    </div>
                </li>
            );
        });
    };
    const render = () => {
        return (
            <ul className="grid-nav">
                {renderList()}
            </ul>
        );
    };

    return render();
};
